import React from 'react';
import {Text, View, StyleSheet } from '@react-pdf/renderer';

const styles = StyleSheet.create({
   
    titleContainer:{
        flexDirection: 'row',
        marginTop: 2,
        marginBottom: 10
    },
    reportTitle:{
        fontSize: 9,
        lineHeight:1.5
    },
  });
  

  const InvoiceThankYouMsg = () => (
    <View style={styles.titleContainer}>
        <Text style={styles.reportTitle}>The booking is powered by Holidays Seychelle {'\n'}Emergency number - +248 437 6666 </Text>
        
    </View>
  );
  
  export default InvoiceThankYouMsg